











import { Component, Vue} from 'vue-property-decorator';
import NavigationTopbar from "./components/NavigationTopbar.vue";
import MenuBar from "./components/MenuBar.vue";
import NavigationFooter from "./components/NavigationFooter.vue";


@Component({
    components: {
        NavigationTopbar,
        MenuBar,
        NavigationFooter
    }
})

export default class App extends Vue {


}
